import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";


const sideBarOption = [
    {
        title: "Users",
        link: "/admin/users"
    },
    {
        title: "Course Categories",
        link: "/admin/coursecategories"
    },
    {
        title: "Course",
        link: "/admin/courses"
    }
];


export const SideBar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const hideHeaderForPaths = "/admin/courses/updatecourse";

    useEffect(() => {
        if (isSidebarOpen) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [isSidebarOpen]);

    if (hideHeaderForPaths.endsWith(location.pathname)) {
        return <></>;
    }

    return (
        <>
            <div className="md:min-h-screen md:w-64 p-4 bg-white md:border-r max-md:w-full">
                {sideBarOption.map((item, index) => {
                    const isActive = location.pathname.startsWith(item.link);

                    return (
                        <div key={index} className="border-b max-md:hidden">
                            <button
                                onClick={() => navigate(item.link)}
                                className={`
                                font-medium w-full p-2 cursor-pointer flex items-center justify-start
                                transition-all
                                ${isActive ? "bg-blue-100 text-blue-600 font-semibold" : "text-gray-700"}
                                hover:bg-gray-100
                            `}
                            >
                                {item.title}
                            </button>
                        </div>
                    );
                })}

                <div className="w-full p-3 md:hidden flex justify-end items-center">

                    {/* Mobile Menu Button */}
                    <button onClick={() => setSidebarOpen(true)}>
                        <span className="material-symbols-outlined text-3xl">menu</span>
                    </button>
                </div>
            </div>

            {isSidebarOpen && (
                <div className="fixed inset-0 z-[10000] flex">

                    {/* BACKDROP */}
                    <div
                        className="fixed inset-0 bg-black bg-opacity-40"
                        onClick={() => setSidebarOpen(false)}
                    />

                    {/* SLIDING DRAWER */}
                    <div className="relative z-[10001] w-72 bg-white h-screen shadow-xl animate-slideIn pb-12">

                        {/* Header */}
                        <div className="flex items-center justify-end p-4 border-b">

                            <button onClick={() => setSidebarOpen(false)}>
                                <span className="material-symbols-outlined text-3xl">close</span>
                            </button>
                        </div>

                        {/* Lesson Items */}
                        <div className="overflow-y-auto max-md:h-[calc(100vh-200px)] p-2">
                            {sideBarOption.map((item, index) => {
                                const isActive = location.pathname.startsWith(item.link);

                                return (
                                    <div key={index} className="border-b">
                                        <button
                                            onClick={() => {
                                                setSidebarOpen(false);
                                                navigate(item.link)
                                            }}
                                            className={`
                                font-medium w-full p-2 cursor-pointer flex items-center justify-start
                                transition-all
                                ${isActive ? "bg-blue-100 text-blue-600 font-semibold" : "text-gray-700"}
                                hover:bg-gray-100
                            `}
                                        >
                                            {item.title}
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}


        </>

    )
}